import type { ReactNode } from 'react'

import classNames from '../../utils/classNames'

interface TextButtonProps {
  variant?: 'blue' | 'green' | 'default'
  size?: 'small' | 'large' | 'default'
  children: ReactNode | string
  type?: 'submit' | 'button'
  onClick?: () => unknown
  className?: string
  inline?: boolean
}

const TextButton = ({
  variant = 'default',
  size = 'default',
  children,
  className = '',
  inline,
  ...rest
}: TextButtonProps) => {
  const COLORS = {
    blue: 'text-highlight',
    green: 'text-primary-btn-bg',
    default: 'text-secondary-btn-txt',
  }

  const SIZES = {
    small: 'text-xs leading-[38px] xl:text-base xl:leading-[42px]',
    large: 'text-base leading-[46px] xl:text-lg xl:leading-[50px]',
    default: 'text-sm leading-10 xl:text-base xl:leading-[42px]',
  }

  return (
    <button
      className={classNames(
        'text-center block underline rounded-md disabled:opacity-50',
        inline ? 'leading-[normal] inline text-left' : '',
        COLORS[variant],
        SIZES[size],
        className,
      )}
      {...rest}>
      {children}
    </button>
  )
}

export default TextButton
